<template>
    <div class="page">
        <loading :show="loading">
        </loading>
        <div class="header row" style="border-bottom: black solid 2px">
            <div class="col-md-6">
                <img src="/static/petrolimexaviation.jpg" class="img-responsive" alt="Image" style="width: 349px">
            </div>
            <div class="col-md-6">
                <span class="pull-right text-uppercase" style="font-size: 14px;font-weight: bold;">
                    {{ $t('summary.minutes_of_meeting') }}
                </span>
            </div>
        </div>
        <div class="body row mt-3">
            <div class="col-md-12 text-center">
                <b class="text-uppercase">{{ $t('summary.minutes_of_meeting') }}
                    <br>{{ $t('summary.audit_result') }} {{ checklist.name }} - {{ checklist.organization ?
            checklist.organization.name : '' }}
                </b><br>
                <span>{{ $t('summary.date') }}: {{ date_now.date() }} {{ $t('summary.month') }} {{ date_now.month() + 1 }}
                    {{ $t('summary.year') }} {{ date_now.year() }} </span>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12 ng-binding">
                <span style="padding: 0;font-size: 13px; font-weight: bold;">1. {{ $t('summary.auditors') }}: </span>
            </div>
            <div class="col-md-12" style="margin-left: 10px">
                <span style="padding: 0; font-weight: bold;"> 1.1. {{ $t('summary.auditor_leader') }}: </span><br>
                <span v-if="teams">
                    <span v-for="(user, key) in teams.Leader" :key="key">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- {{ user.gender == "1" ? $t('summary.mr') : $t('summary.mrs') }}:
                        {{ user.name }} - {{ user.pos_name }}<br>
                    </span>
                </span>
            </div>
            <div class="col-md-12" style="margin-left: 10px">
                <span style="padding: 0; font-weight: bold;"> 1.2. {{ $t('summary.auditor_auditor') }} : </span><br>
                <span v-if="teams">
                    <span v-for="(user, key) in teams.Auditor" :key="key">
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- {{ user.gender == "1" ? $t('summary.mr') : $t('summary.mrs') }}:
                        {{ user.name }} - {{ user.pos_name }}<br>
                    </span>
                </span>
            </div>
        </div>

        <div class="row">
            <div class="col-md-12 ng-binding">
                <span style="padding: 0;font-size: 13px;font-weight: bold;">
                    2. {{ $t('summary.auditees') }}: </span>
                {{ checklist.organization ? checklist.organization.name : '' }} - {{ $t('summary.address') }} :
                {{ checklist.organization ? checklist.organization.address : '' }}
            </div>
            <div class="col-md-12" v-if="teams">
                <span v-for="(user, key) in teams.Auditee" :key="key">
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;- {{ user.gender == "1" ? $t('summary.mr') : $t('summary.mrs') }}:
                    {{ user.name }} - {{ user.pos_name }}<br></span>
            </div>
            <div class="col-md-12 ">
            </div>
        </div>

        <div class="row">
            <div class="col-md-12">
                <span style="padding: 0;font-size: 13px;font-weight: bold;">3. {{ $t('summary.audit_period') }}: </span>
                <span style="padding: 0;" class="ng-binding">
                    {{ $t('summary.from') }}
                    {{ checklist.starting_date ? $moment(checklist.starting_date).format('DD-MM-YYYY') : '' }}
                    {{ $t('summary.to') }}
                    {{ date_now.date() }}-{{ date_now.month() + 1 }}-{{ date_now.year() }}
                </span><br>
            </div>
            <div class="col-md-12 mt-3">
                <span style="padding: 0;font-size: 13px;font-weight: bold;">4. {{ $t('summary.auditors_comment') }}:
                </span>
            </div>
            <div class="col-md-12 mt-1">
                <ckeditor type="classic" v-model="summary.conclusion" />
                <error :error="errors.conclusion"></error>
            </div>
            <div class="col-md-12 mt-3">
                <span style="padding: 0;font-size: 13px;font-weight: bold;">5. {{ $t('summary.auditees_comment') }}:
                </span>
            </div>
            <div class="col-md-12 mt-1">
                <ckeditor type="classic" v-model="summary.self_assessment" />
                <error :error="errors.self_assessment"></error>
            </div>
        </div>
        <div class="row">
            <span class="col-md-12">{{ $t('summary.p1') }}</span>
            <span class="col-md-12 p-0"> <b>{{ $t('summary.p2') }}</b></span>
        </div>
        <div class="row mt-3">
            <table class="col-md-12">
                <thead style="background-color: #fff;">
                    <tr class="text-center">
                        <th style="width: 50%" class="text-uppercase">{{ $t('summary.auditor_representative') }}</th>
                        <th style="width: 50%" class="text-uppercase">{{ $t('summary.auditee_representative') }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr style="height: 12rem;">
                        <!-- <td class="button-profile "><span class="fontsummary">Tên trưởng đoàn</span></td> -->
                        <!-- <td class="button-profile "><span class="fontsummary">Tên đại diện tổ chức</span></td> -->
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="row" v-if="show_custom_checklist_item">

            <div class="table-responsive">
                <table class="table table-hover">
                    <thead class="thead-light">
                        <tr>
                            <th>
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" id="customChk1" @change="checkAll()" v-model="check_all"
                                        class="custom-control-input">
                                    <label for="customChk1" class="custom-control-label"></label>
                                </div>
                            </th>
                            <th>Result</th>
                            <th>Header</th>
                            <th>Content</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, key) in item_reports" :key="key">
                            <td>
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" :id="item.id" class="custom-control-input"
                                        v-model="item.select">
                                    <label :for="item.id" class="custom-control-label"></label>
                                </div>
                            </td>
                            <td style="width: 10%">{{ item.checklist_item_status ? item.checklist_item_status.code : '' }}
                            </td>
                            <td style="width: 10%">{{ item.header }}</td>
                            <td style="width: 80%" v-html="item.content">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

        </div>
        <div class="row mt-3 ">
            <div class="col-md-12">
                <span class="link" @click="showCustom()">
                    <i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Custom result
                </span>
                <button class="btn btn-primary pull-right" @click="create()">
                    <i class="fa fa-arrow-right"></i> {{ $t('summary.save')}}
                </button>
            </div>
        </div>
    </div>
</template>
<script>import Helper from '@/Helper'
import { getAssessmentTeam } from '@/service/Apis'
export default {
  name: 'summaryChk',
  components: {},
  props: [],
  data () {
    return {
      loading: false,
      date_now: this.$moment(),
      users: null,
      checklist: {},
      summary: {},
      errors: {},
      item_reports: [],
      check_all: true,
      show_custom_checklist_item: false,
      teams: [],
      checklistId: this.$route.params.checklist_id
    }
  },
  computed: {
  },
  mounted () {
    Promise.all([
      this.$store.dispatch('Checklist/showChecklist', {
        checklist: { id: this.checklistId }
      }),
      this.$store.dispatch('Summary/getChecklistItemReport', {
        checklist: { id: this.checklistId }
      }),
      this.$store.dispatch('Summary/getMinutesLast', {
        checklist: { id: this.checklistId }
      })
    ])
      .then(res => {
        this.checklist = res[0]
        this.item_reports = res[1]
        this.summary = res[2]
        this.item_reports.forEach(element => {
          element.select = true
        })
      })
      .catch(errors => {
      })
    this.fetchTeam()
  },
  methods: {
    async fetchTeam () {
      try {
        const res = await getAssessmentTeam(this.checklistId)
        this.teams = Helper.sortTeam(res.data)
      } catch (error) {
        console.log(error)
      }
    },
    create () {
      var ids = []
      this.item_reports.forEach(element => {
        if (element.select) {
          ids.push(element.id)
        }
      })
      this.summary.list_items_report_alias = ids
      this.summary.self_assessment = Helper.replaceHtml(
        this.summary.self_assessment
      )
      this.summary.conclusion = Helper.replaceHtml(this.summary.conclusion)
      this.$store
        .dispatch('Summary/createSummary', {
          checklist: { id: this.$route.params.checklist_id },
          summary: this.summary
        })
        .then(res => {
          this.$router.push('summary/' + res.id)

          this.loading = false
        })
        .catch(errors => {
          if (errors.status === 422) {
            this.errors = errors.data.error
          }
          ;
          this.loading = false
        })
    },
    checkAll () {
      this.item_reports.forEach(element => {
        element.select = this.check_all
      })
    },
    showCustom () {
      this.show_custom_checklist_item = !this.show_custom_checklist_item
    }
  }
}
</script>
<style lang="scss">
.page {
    min-height: 24.7cm;
    padding: 1cm;
    margin: 5px auto;
    border: 1px #D3D3D3 solid;
    background: white;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/views/checklist/view/summaryChk.vue